// theme.js
import { createTheme, alpha } from '@mui/material/styles';

export function createAppTheme(mode = 'light') {
  const isDark = mode === 'dark';

  return createTheme({
    palette: {
      mode,
      primary: {
        main: isDark ? '#68B57A' : '#1F6B43',
        light: '#94C97E',
        dark: '#145132',
      },
      secondary: {
        main: '#BAD9AD',
      },
      error: {
        main: '#D9534F',
      },
      warning: {
        main: isDark ? '#F4C95D' : '#B7791F',
      },
      background: {
        default: isDark ? '#0f1311' : '#FAFAFA',
        paper: isDark ? '#171c19' : '#FFFFFF',
      },
      text: {
        primary: isDark ? '#F4F7F5' : '#212121',
        secondary: isDark ? '#B8C4BD' : '#666666',
      },
      divider: isDark ? alpha('#FFFFFF', 0.12) : alpha('#000000', 0.12),
    },
    typography: {
      fontFamily: [
        'Inter',
        '-apple-system',
        'BlinkMacSystemFont',
        '"Segoe UI"',
        'Helvetica',
        'Arial',
        'sans-serif',
        '"Apple Color Emoji"',
        '"Segoe UI Emoji"',
      ].join(','),
    },
    components: {
      MuiCssBaseline: {
        styleOverrides: {
          body: {
            backgroundColor: isDark ? '#0f1311' : '#FAFAFA',
          },
        },
      },
      MuiPaper: {
        styleOverrides: {
          root: {
            backgroundImage: 'none',
          },
        },
      },
      MuiTable: {
        styleOverrides: {
          root: {
            backgroundColor: isDark ? '#171c19' : '#f5f5f5',
          },
        },
      },
      MuiTableBody: {
        styleOverrides: {
          root: {
            backgroundColor: isDark ? '#171c19' : '#fafafa',
          },
        },
      },
      MuiTableCell: {
        styleOverrides: {
          root: {
            backgroundColor: isDark ? '#171c19' : '#fafafa',
            borderColor: isDark ? alpha('#FFFFFF', 0.1) : alpha('#000000', 0.12),
          },
          head: {
            backgroundColor: isDark ? '#222923' : '#e0e0e0',
          },
        },
      },
    },
  });
}

const theme = createAppTheme('light');

export default theme;
